import React, {Component} from 'react';
import Question from './question';
import Relay from 'react-relay';
import RaisedButton from 'material-ui/lib/raised-button';
import TextField from 'material-ui/lib/text-field';
import cookie from '../../helper/cookie'

class CreateForm extends Component{

  dateObj = new Date();

  state={

    project_id:this.props.viewer.pid,//TODO get it and set it

    conflicting_questions:{
      timestamps:[],
      mapping:[]
    },

    childrenStates: [{question_text:'',
              isToggled : false,
              type:'Subjective',
              timestamp: this.dateObj.getTime(),
              number:this.props.number,
              mcq_options:['','','',''],
              slider_options:['1:10',['','','']]
            }]
  };



  handleChildStateChange = (s) => {
    console.log("a child's state changed");
    var temp = this.state;
    var i = 0;
    for (i = 0; i < temp.childrenStates.length; i++ ){
      if ( s.timestamp == temp.childrenStates[i].timestamp ){
        temp.childrenStates[i] = s;
        this.setState(temp);
        break;
      }
    }
    console.log("updated it in the parent");
  };


  self = this;

  giveSampleState = () => {
    var dateObj = new Date();
    return ({

        question_text:'',
        isToggled:false,
        type:'Subjective',
        timestamp:dateObj.getTime(),
        number:this.props.number,
        mcq_options:['','','',''],
        slider_options:['1:10',['','','']]

    });
  };

  giveState = () => {
    //alert(JSON.stringify(this.state));
    console.log(JSON.stringify(this.state));
  };

  addQuestion = () => {

    ///console.log("adding new question")
    var temp = this.state;
    var numOfQuestions = temp.childrenStates.length;
    temp.childrenStates[numOfQuestions] = this.giveSampleState();
    console.log("after adding -- temp ma");
    temp.childrenStates.map(function(q){
      console.log(q.timestamp);
    });
    this.setState(temp);

    console.log("after adding -- parent ma");
    this.state.childrenStates.map(function(q){
      console.log(q.timestamp);
    });
  };

  deleteQuestion = (t) => {
    console.log(t);
    if (this.state.childrenStates.length == 1){
      alert("Cannot delete the one and only question!");
      return(null);
    }else{
      console.log("deleting a child");
      var temp = this.state;
      var i =0;
      for (i = 0; i < temp.childrenStates.length; i++ ){
        console.log(temp.childrenStates[i].timestamp);
        if ( t == temp.childrenStates[i].timestamp ){
          // if (i == 0){
          //   temp.childrenStates = temp.childrenStates.slice(1);
          //   this.setState(temp);
          // }else{
          //   temp.childrenStates = temp.childrenStates.slice(0,i) + temp.childrenStates.slice(i+1);
          //   this.setState(temp);
          // }
          console.log("here");
          temp.childrenStates.splice(i, 1);
          this.setState(temp);
          console.log(this.state);
          break;
        }
      }
      console.log("deleted succesfully");
    }
  }

  //is it returns true -- the togglebutton will toggle, it wont otherwise.
  handleToggle = (timestamp) =>{
    var temp = this.state;
    var index = temp.conflicting_questions.timestamps.indexOf(timestamp);
    if( index >= 0 ){
      temp.conflicting_questions.timestamps.splice(index, 1);
      this.setState(temp);
      console.log(this.state.conflicting_questions.timestamps);
      return true;
    }else if(temp.conflicting_questions.timestamps.length == 2){
      alert("Remove a conflicting question to add this one.")
      return false;
    }else{
      var length = temp.conflicting_questions.timestamps.length;
      temp.conflicting_questions.timestamps[length] = timestamp;
      this.setState(temp);
      console.log(this.state.conflicting_questions.timestamps);
      return true;
    }
  }

  updateMapping = (e) => {
    var temp = this.state;
    // s = e.target.value;
    temp.conflicting_questions.mapping = e.target.value.trim().split(" ").map(function(t){return parseInt(t)});
    this.setState(temp);
    console.log(this.state);

  }

  submit = () =>{
    console.log(this.state);
    var params = JSON.stringify({"info":this.state});
    var url = 'http://surveymate-io.herokuapp.com/api/questions/addQuestions';
    var responseCode;
    var responseText;
    var self=this;
    var response = fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: params
    }).then(function (response) {
        responseCode = response.status;
        responseText = response.statusText;
        return response.text();
    }).then(function (result) {
        var jsonData = JSON.parse(result);
        if (responseCode == 200) {
          console.log("success");
          alert("Form succesfully created")
        }
        else {
          console.log("failure");
        }
    }).catch(function (error) {
      console.error('An error occured');
      console.error(error);
    });
  }

  render(){
    //console.log(this.handleChildStateChange);
    // console.log("rendering");
    var t = this.handleToggle;
    var f = this.handleChildStateChange;
    var d = this.deleteQuestion;
    var numOfQuestions = this.state.childrenStates.length;
    var counter = 0;
    var kv = ""
    var questions=this.state.childrenStates.map(function(s){
      counter = counter + 1;
      if ( counter == numOfQuestions){ kv="in" }
      return(
        <div className="panel panel-default">
          <div className="panel-heading">
              <h4 className="panel-title">
                  <a data-toggle="collapse" data-parent="#accordion" href={"#collapse"+counter.toString()}>Question {counter}</a>
              </h4>
          </div>
          <div id={"collapse"+counter.toString()} className={"panel-collapse collapse"+kv}>
            <div className="panel-body">
                  <Question handleToggle={t} ref={"q"+counter.toString()} passedState={s} deleteSelf={d} className="panel-collapse collapse" onStateChange={f}></Question>
            </div>
          </div>
        </div>
      );
    });
    if (cookie.get('access_token') != null) {
    return(
      <center className="container-fluid" style={{maxWidth:1000}}>

        <div className="panel-group" id="accordion">
          {questions}
        </div>

        <button style = {{display:"none"}}  className="btn btn-sm btn-info" onClick={this.giveState}>{"State?"}</button>
        <button style = {{display:"none"}} className="btn btn-md btn-primary" onClick={this.addQuestion.bind(this)}>Add a new question</button>
        <RaisedButton label="+ Add new Question" secondary={true}  onClick={this.addQuestion.bind(this)} />
        <br/ ><br />
        <span>Enter the mapping for the relation between the options of the conflicting questions: </span>
        <TextField hintText="Enter the mapping" onChange={this.updateMapping.bind(this)} />
        <br /><br />
        <RaisedButton label="GO" secondary={true} onClick={this.submit} style={{backgroundColor:"#0000FF"}} />

      </center>
    );
    }
  else{
    window.location.href = "/#/login";
    return(<div></div>);
  }
  }
}

export default Relay.createContainer(CreateForm, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Conversation {
        name
        pid
      }
    `
  }
});



/** WEBPACK FOOTER **
 ** ./src/views/questions/index.js
 **/